import { useEffect, useState } from "react";
import axios from "axios";
import uuid from "react-uuid";
import dayjs from "dayjs";
// import data_bannerTwo from "../data/data_bannerTwo";

// const apiUrl = "https://aed.mju.ac.th/api/arch/banners/";
// const apiUrl = "https://aed.mju.ac.th/API/arch/";
const apiUrl = process.env.REACT_APP_API_URL;
const todaysDate = new Date();

// import constDataBanner from '../data/data_banner'
function showUntilChecker(imgUntil) {
    const imgDate = dayjs(imgUntil).unix();
    // console.log("imgDate:", imgDate);
    // console.log("todaysDate:", dayjs().unix());
    if (imgDate >= dayjs().unix()) {
        // console.log("true");
        return true;
    } else {
        // console.log("false");
        return false;
    }
}
const handleImageClick = (imgLink) => {
    window.open(imgLink, "_blank");
};

const showConsole = false;

export function Banner() {
    const genBannerItem = (item, index) => {
        // showConsole && console.log("until:", item.imgUntil);
        // showConsole && console.log("untilCheck: ", showUntilChecker(item.imgUntil));
        if (showUntilChecker(item.imgUntil)) {
            return (
                <div
                    key={`bannerTop-${index}`}
                    // id="banner_top_full_widthaa"
                    className="imageBannerHolder"
                >
                    <img
                        // key={"img-" + index}
                        src={item.imgSrc}
                        className={`img-fluid imageBanner ${
                            item.imgLink.length ? "imagePointer" : null
                        }`}
                        alt={item.imgAlt}
                        onClick={() =>
                            item.imgLink.length
                                ? handleImageClick(item.imgLink)
                                : null
                        }
                    />
                </div>
            );
            // } else {
            //   return null;
        }
    };

    const [banners, setBanners] = useState([]);
    useEffect(() => {
        // const showConsole = true;
        const fetchData = async () => {
            try {
                const result_apiUrlBanners = await axios.get(
                    `${apiUrl}banners/top/index.json`
                );
                if (result_apiUrlBanners.data.length > 0) {
                    setBanners(result_apiUrlBanners.data);
                    showConsole &&
                        console.log("Banner", result_apiUrlBanners.data);
                }
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);
    // console.log("bannerTop: ", banners);

    return <>{banners.map((item, index) => genBannerItem(item, index))}</>;
}

export function BannerPortrait() {
    // const showConsole = true;
    const genBannerItem = (item, index) => {
        // showConsole && console.log("until:", item.imgUntil);
        // showConsole && console.log("untilCheck: ", showUntilChecker(item.imgUntil));
        if (showUntilChecker(item.imgUntil)) {
            return (
                <div
                    key={`bannerPortrait-${index}`}
                    // id="banner_top_full_width"
                    className="imageBannerHolderHalf"
                >
                    <img
                        // key={"img-" + index}
                        src={item.imgSrc}
                        className={`img-fluid imagePortrait ${
                            item.imgLink.length ? "imagePointer" : null
                        }`}
                        alt={item.imgAlt}
                        onClick={() =>
                            item.imgLink.length
                                ? handleImageClick(item.imgLink)
                                : null
                        }
                    />
                </div>
            );
            // } else {
            //   return null;
        }
    };

    const [banners, setBanners] = useState([]);
    useEffect(() => {
        // const showConsole = true;
        const fetchData = async () => {
            try {
                const result_apiUrlBanners = await axios.get(
                    `${apiUrl}banners/portrait/index.json`
                );
                if (result_apiUrlBanners.data.length > 0) {
                    setBanners(result_apiUrlBanners.data);
                    showConsole &&
                        console.log("Banner", result_apiUrlBanners.data);
                }
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);
    showConsole && console.log("bannerTop: ", banners);

    return <>{banners.map((item, index) => genBannerItem(item, index))}</>;
}

export function BannerEn() {
    // const showConsole = true;
    const genBannerItem = (item, index) => {
        showConsole && console.log("until:", item.imgUntil);
        showConsole &&
            console.log("untilCheck: ", showUntilChecker(item.imgUntil));
        if (showUntilChecker(item.imgUntil)) {
            return (
                <div
                    key={`bannerTop-${index}`}
                    id="banner_top_full_width"
                    className="imageBannerHolder"
                >
                    <img
                        // key={"img-" + index}
                        src={item.imgSrc}
                        className={`img-fluid imageBanner ${
                            item.imgLink.length ? "imagePointer" : null
                        }`}
                        alt={item.imgAlt}
                        onClick={() =>
                            item.imgLink.length
                                ? handleImageClick(item.imgLink)
                                : null
                        }
                    />
                </div>
            );
            // } else {
            //   return null;
        }
    };

    const [banners, setBanners] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result_apiUrlBanners = await axios.get(
                    `${apiUrl}banners/top/index.json`
                );
                if (result_apiUrlBanners.data.length > 0) {
                    setBanners(result_apiUrlBanners.data);
                    showConsole &&
                        console.log("Banner", result_apiUrlBanners.data);
                }
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);
    showConsole && console.log("bannerTop: ", banners);

    return <>{banners.map((item, index) => genBannerItem(item, index))}</>;
}

// export function HeaderBanner3() {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const imgSrc =
//         "https://arch.mju.ac.th/th/images/banners/banner_greenoffice3.png";
//     // const imgLink = "https://arch.mju.ac.th/greenoffice";
//     const imgAlt = "Green Office";

//     // const handleImageClick = (imgLink) => {
//     //   window.open(imgLink, "_blank");
//     // };
//     useEffect(() => {
//         // const headers = {
//         //     "Content-Type": "application/json",
//         //     Authorization: apiKey,
//         // };
//         const fetchData = async () => {
//             try {
//                 const result = await axios.get(apiUrl);

//                 // console.log("api data: ", result.data);
//                 setData(result.data.response);
//                 setLoading(false);
//             } catch (e) {
//                 console.error("Error: ", e);
//                 setLoading(false);
//             }
//         };
//         fetchData();
//         // eslint-disable-next-line
//     }, []);

//     return (
//         <div id="banner_palace_full_width" className="HeaderBannerHolder">
//             {/* {console.log(data)} */}
//             {loading ? (
//                 <div
//                     style={{
//                         fontSize: "0.7rem",
//                         color: "#aeaeae",
//                         padding: "4px",
//                     }}
//                 >
//                     Loading content...
//                 </div>
//             ) : (
//                 <div>
//                     <img
//                         src={imgSrc}
//                         className="HeaderBanner"
//                         alt={imgAlt}
//                         // onClick={handleImageClick}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// }

export function HeaderBanner() {
    const [bannerHeader, setBannerHeader] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result_apiUrlBanners = await axios.get(
                    `${apiUrl}banners/header/index.json`
                );
                const bannerHeaderActive =
                    result_apiUrlBanners.data.bannerHeader.filter((item) =>
                        showUntilChecker(item.imgUntil)
                    );
                console.log("bannerHeaderActive:", bannerHeaderActive);
                setBannerHeader(bannerHeaderActive[0]);
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();
    }, []);

    return (
        <div id="banner_palace_full_width" className="HeaderBannerHolder">
            <div>
                <img
                    src={bannerHeader.imgSrc}
                    className={
                        bannerHeader.imgLink !== ""
                            ? "HeaderBanner imagePointer"
                            : "HeaderBanner"
                    }
                    alt={bannerHeader.imgAlt}
                    onClick={() => handleImageClick(bannerHeader.imgLink)}
                />
            </div>
        </div>
    );
}

export function BannerDouble() {
    // const showConsole = true;
    const handleImageClick = (imgLink) => {
        window.open(imgLink, "_blank");
    };
    const [banners, setBanners] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result_apiUrlBanners = await axios.get(
                    `${apiUrl}banners/double/index.json`
                );
                if (result_apiUrlBanners.data.length > 0) {
                    setBanners(result_apiUrlBanners.data);
                    showConsole &&
                        console.log("DoubleBanner:", result_apiUrlBanners.data);
                } else {
                    showConsole && console.log("DoubleBanner: Fail");
                }
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);

    const renderedComponents = [];
    for (let i = 0; i < banners.length; i++) {
        const item = banners[i];
        if (showUntilChecker(item.imgUntil)) {
            renderedComponents.push(
                <div key={uuid()} className="imageBannerTwoHolder">
                    <img
                        src={item.imgSrc}
                        className={
                            item.imgLink !== ""
                                ? "imageBannerTwo imagePointer"
                                : "imageBannerTwo"
                        }
                        alt={item.imgAlt}
                        onClick={() =>
                            item.imgLink.length
                                ? handleImageClick(item.imgLink)
                                : null
                        }
                    />
                </div>
            );
        }
    }

    if (renderedComponents.length > 0) {
        return (
            <>
                <div
                    id="bannerDouble"
                    className="row row-cols-1 row-cols-md-2 g-3 gx-md-4"
                    style={{
                        marginTop: "20px",
                    }}
                >
                    {renderedComponents}
                </div>
            </>
        );
    }
}

export function PublicNews() {
    // const showConsole = true;
    const handleImageClick = (imgLink) => {
        window.open(imgLink, "_blank");
    };
    const [banners, setBanners] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await axios.get(
                    `${apiUrl}banners/publicnews/index.json`
                );
                if (result.data.length > 0) {
                    setBanners(result.data);
                    showConsole && console.log("PublicNews:", result.data);
                } else {
                    showConsole && console.log("PublicNews: Fail");
                }
            } catch (e) {
                console.error("fetch ERROR: ", e);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);

    const renderedComponents = [];
    for (let i = 0; i < banners.length; i++) {
        const item = banners[i];

        if (showUntilChecker(item.imgUntil)) {
            renderedComponents.push(
                <div key={uuid()} className="imagePublicNewsHolder">
                    <img
                        src={item.imgSrc}
                        // className="imagePublicNews"
                        className={
                            item.imgLink !== ""
                                ? "imagePublicNews imagePointer"
                                : "imagePublicNews"
                        }
                        alt={item.imgAlt}
                        onClick={() =>
                            item.imgLink.length
                                ? handleImageClick(item.imgLink)
                                : null
                        }
                    />
                </div>
            );
        }
    }

    if (renderedComponents.length > 0) {
        return (
            <>
                <div
                    id="publicNews"
                    className="row row-cols-1 row-cols-md-2 g-3 gx-md-4"
                    style={{
                        marginTop: "20px",
                    }}
                >
                    {renderedComponents}
                </div>
            </>
        );
    }
}

// export default Banner;